export default "__VITE_ASSET__OWQmyNYN__"